import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { v4 as uuid } from 'uuid';
import { useLocation } from "react-router-dom";

//const trakApiUrl ="http://localhost:6001/sense/tracking";  
const trakApiUrl ="https://sensewebstg.simplexts.com.au/sense/tracking";
const brandId = 2;

let channel = "";
let browser = "";
let appVersion: any = null;

const deviceInfo=()=>{
  const userAgent = navigator.userAgent;
  const isAndroid = userAgent.indexOf("Android") > -1;
  const isiOS = !!userAgent.match(/iPad|iPhone|iPod/);

  if (isAndroid) {
    appVersion = "Android " + parseFloat(userAgent.slice(userAgent.indexOf("Android") + 8));
  } else if (isiOS) {
    const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    const version = match ? [parseInt(match[1], 10), parseInt(match[2], 10), parseInt(match[3] || '0', 10)] : [];
    appVersion = `iOS ${version.join(".")}`;
  } else {
    appVersion = "Web";
  }
  

  // detect device type
  if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/)) {
    channel = "Mobile";
  } else {
    channel = "Web";
  }

  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
    browser = 'Opera';
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    browser = 'Chrome';
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    browser = 'Safari';
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    browser = 'Firefox';

  } else {
    browser = 'unknown';
  }
  localStorage.setItem("channel",channel)
  localStorage.setItem("browser",browser)
  localStorage.setItem("appVersion",appVersion)
}

const TrackCategory = {
  events: "events",
  pages: "pages",
  payment_log:"payment_log",
  empty: "empty"
}

const useTrackEvent = () => {
  const location = useLocation();

 
  const trackerEndPoint = async (data: any) => {
    try {
      await axios.post(`${trakApiUrl}/user_tracking`, data)
    } catch (error) {
      // console.error("error while tracker end point", error);
    }
  }

  const trackerPaymentLogs = async (data: any) => {
    try {
      await axios.post(`${trakApiUrl}/payment_logs`, data)
    } catch (error) {
      // console.error("error while tracker end point", error);
    }
  }

  useEffect(() => {

    let pervious_path = localStorage.getItem("previous_path")
    let chanel=localStorage.getItem("channel")
    let browser=localStorage.getItem("browser")
    let version=localStorage.getItem("appVersion")
    if(!chanel || !browser || !version){
      deviceInfo();
    }
    if (!sessionStorage.getItem("trackId")) {
      let obj = { category: TrackCategory.empty, page_track: location.pathname == "/" ? "/" : location.pathname  }
      if (!localStorage.getItem("user_ip")) {
        (async () => {
          const response = await fetch('https://api.ipify.org/?format=json');
          const data = await response?.json();
           localStorage.setItem("user_ip", data?.ip);
           addEvent(obj)
           localStorage.setItem("previous_path", location.pathname);
          } 
        )()
      }
      else {
        addEvent(obj)
        localStorage.setItem("previous_path", location.pathname);
      }
     
    } else if (location.pathname != pervious_path) {
        let obj = { category: TrackCategory.pages, page_track: location.pathname == "/" ? "/" : location.pathname }
        addEvent(obj)
        localStorage.setItem("previous_path", location.pathname);
    }
    
  }, [location])

  
  
  const addEvent = (data: any) => {
    return
    let { category } = data;
    let { events } = data
    if (sessionStorage.getItem("trackId") == null) {
      if (category === TrackCategory.empty) {
        sessionStorage.setItem("trackId", uuid() + "_" + Date.now())
        let obj = {
          tracking_id: sessionStorage.getItem("trackId"),
          brand_id: brandId,
          page_track: data.page_track,
          category: TrackCategory.pages,
          ip_address:localStorage.getItem("user_ip"),
          channel:localStorage.getItem("channel"),
          browser:localStorage.getItem("browser"),
          version:localStorage.getItem("appVersion")
        }
        trackerEndPoint(obj)
      }
    }
    else {
      if (category === TrackCategory.events) {
        trackerEndPoint({...data, tracking_id: sessionStorage.getItem("trackId")})
      } else if (category === TrackCategory.pages) {
        trackerEndPoint({...data, tracking_id: sessionStorage.getItem("trackId")})
      }
      else if (category === TrackCategory.payment_log) {
        trackerPaymentLogs({...events,tracking_id: sessionStorage.getItem("trackId")})
        
      }
      
    }
  }
  
  return [addEvent];
};

export default useTrackEvent;